import { h } from 'preact';
import cx from 'classnames';

export const Column = (props) => {
	let { children } = props;

	// Bail if we have nothing valid to display
	if (!Array.isArray(children) || !children.length) {
		return null;
	}

	return (
		<div class={cx('col', props.class)}>
			{children}
		</div>
	);
};

export default Column;
